import axiosInstance from "./axiosInstance";

export interface PropertyAvailabilityListDateRangeApi {
  dateRangeIndex: number;
  dateLabel: string;
  startDate: string;
  endDate: string;
  status: number;
  numberOfRooms: number;
}

export interface PropertyAvailabilityListRoomConfigApi {
  propertyRoomTypeId: number;
  roomPublicId: string;
  roomTypeId: number;
  roomTypeName: string;
  roomNames: string;
  roomNamesArray: string[];
  numberOfRooms: number;
  blockedRooms: number;
  availableRooms: number;
}

export interface PropertyAvailabilityListItemApi {
  publicId: string;
  propertyId: number;
  propertyPublicId: string;
  propertyName: string;
  propertyTypeName: string;
  isActive: boolean;
  isReleased: boolean;
  dateRanges: PropertyAvailabilityListDateRangeApi[];
  dateLabels: string[];
  roomConfigs: PropertyAvailabilityListRoomConfigApi[];
  availableTourOperatorTypeIds: number[];
  availableTourOperatorTypeNames: string[];
}

export interface PropertyAvailabilityListResponse {
  totalCount: number;
  items: PropertyAvailabilityListItemApi[];
}
export interface PropertyApi {
  publicId: string;
  venueName: string;
  propertyName: string;
  propertyCode: string;
  propertyGrade: string;
  propertyTypeName: string;
  phoneNumber: string;
  checkInTime: string;
  checkOutTime: string;
  totalFloors: number;
  totalRooms: number;
  maxAdults: number;
  maxChildren: number;
  capacity: number;
  isActive: boolean;
}

export interface RoomTypeApi {
  id: number;
  publicId: string;
  code: string;
  roomName: string;
  description: string;
  isActive: boolean;
}

export interface PropertyRoomTypeApi {
  propertyRoomTypeId: number;
  publicId: string;
  roomTypeId: number;
  roomTypeName: string;
  numberOfRooms: number;
  maxAdults: number;
  maxChildren: number;
  maxOccupancy: number;
  minAdults: number;
  minOccupancy: number;
  roomNames: string;
  roomNamesArray: string[];
  amenityIds: number[];
}

export interface PropertyDetailsApi {
  propertyId: number;  
  publicId: string;
  venueId: number;
  venueName: string;
  propertyName: string;
  propertyCode: string;
  propertyGradeId: number;
  propertyGrade: string;
  propertyTypeId: number;
  propertyTypeName: string;
  address: string;
  primaryContact: string;
  primaryEmail: string;
  phoneNumber: string;
  checkInTime: string;
  checkOutTime: string;
  childAgeMax: number;
  amenityIds: number[];
  roomTypes: PropertyRoomTypeApi[];
}

export interface TourOperatorTypeApi {
  tourOperatorTypeId: number;
  typeName: string;
  code: string;
  category: string;
  isActive: boolean;
  description: string;
  createdBy: number;
  updatedBy: number | null;
  createdAt: string;
  updatedAt: string | null;
}

export interface PropertyAvailabilityOverridePayload {
  date: string;
  status: number;
  numberOfRooms: number;
}

export interface PropertyAvailabilityDateRangePayload {
  startDate: string;
  endDate: string;
  overrides: PropertyAvailabilityOverridePayload[];
}

export interface PropertyAvailabilityRoomConfigPayload {
  propertyRoomTypeId: number;
  roomPublicId: string;
  roomTypeName: string;
  numberOfRooms: number;
}

export interface CreatePropertyAvailabilityPayload {
  propertyId: number;
  dateRanges: PropertyAvailabilityDateRangePayload[];
  roomConfigs: PropertyAvailabilityRoomConfigPayload[];
  availableTourOperatorTypeIds: number[];
  isActive: boolean;
  isReleased: boolean;
}

export interface PropertyTypeApi {
  id: number;
  publicId: string;
  name: string;
  code: string;
  isActive: boolean;
  createdAt: string;
  createdBy: string;
  updatedAt: string | null;
  updatedBy: string | null;
  deletedAt: string | null;
  deletedBy: string | null;
}

export interface UpdateAvailabilityStatusPayload {
  isActive: boolean;
}

export interface PropertyAvailabilityDateRangeApi {
  dateRangeIndex: number;
  dateLabel: string;
  startDate: string;
  endDate: string;
  status: number;
  numberOfRooms: number;
}

export interface PropertyAvailabilityRoomConfigApi {
  propertyRoomTypeId: number;
  roomPublicId: string;
  roomTypeName: string;
  numberOfRooms: number;
}

export interface PropertyAvailabilityDetailsApi {
  publicId: string;
  propertyId: number;
  propertyName: string;
  propertyTypeName: string;
  isActive: boolean;
  isReleased: boolean;
  dateRanges: PropertyAvailabilityDateRangeApi[];
  dateLabels: string[];
  roomConfigs: PropertyAvailabilityRoomConfigApi[];
  availableTourOperatorTypeIds: number[];
}

export interface CreatePropertyAvailabilityBlockPayload {
  propertyId: number;
  propertyRoomTypeId: number;
  numberOfRooms: number;
  blockStartDate: string;
  blockEndDate: string;
  availableTourTypeIds: number[];
  remark: string;
  isActive?: boolean;
}

export interface PropertyAvailabilityBlockTourTypeApi {
  tourOperatorTypeId: number;
  typeName: string;
  code: string;
  category: string;
}

export interface PropertyAvailabilityBlockItemApi {
  propertyAvailabilityBlockId: number;
  publicId: string;
  propertyId: number;
  propertyPublicId: string;
  propertyName: string;
  propertyRoomTypeId: number;
  propertyRoomTypePublicId: string;
  roomTypeId: number;
  roomTypeName: string;
  numberOfRooms: number;
  blockStartDate: string;
  blockEndDate: string;
  availableTourTypeIds: number[];
  availableTourTypes: PropertyAvailabilityBlockTourTypeApi[];
  remark: string;
  isActive: boolean;
  createdBy: number;
  createdAt: string;
  updatedBy: number | null;
  updatedAt: string | null;
}

export interface PropertyAvailabilityBlockListResponse {
  items: PropertyAvailabilityBlockItemApi[];
  pageNo: number;
  pageSize: number;
  totalCount: number;
  pageNumber: number;
}

export interface PropertyAvailabilityBlockDetailsApi {
  propertyAvailabilityBlockId: number;
  publicId: string;
  propertyId: number;
  propertyPublicId: string;
  propertyName: string;
  propertyRoomTypeId: number;
  propertyRoomTypePublicId: string;
  roomTypeId: number;
  roomTypeName: string;
  numberOfRooms: number;
  blockStartDate: string;
  blockEndDate: string;
  availableTourTypeIds: number[];
  availableTourTypes: PropertyAvailabilityBlockTourTypeApi[];
  remark: string;
  isActive: boolean;
  createdBy: number;
  createdAt: string;
  updatedBy: number | null;
  updatedAt: string | null;
}

export interface PropertyAvailabilityActivityLogApi {
  logId: number;
  moduleName: string;
  actionType: string;
  entityName: string;
  entityKey: string;
  oldValue: string;
  newValue: string;
  ipAddress: string;
  performedBy: string;
  performedById: number;
  performedAt: string;
  remarks: string;
}

export interface PropertyAvailabilityActivityLogsResponse {
  items: PropertyAvailabilityActivityLogApi[];
  total: number;
}

export const getAuthHeader = () => {
  const token = localStorage.getItem("fhims_auth_token");

  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const getPropertyAvailabilities = async (params: {
  q?: string;
  propertyTypeId?: number;
  pageNo: number;
  pageSize: number;
}): Promise<PropertyAvailabilityListResponse> => {
  const res = await axiosInstance.get(
    "/property-availability/list",
    {
      headers: getAuthHeader(),
      params,
    }
  );

  return res.data;
};

export const getProperties = async (): Promise<PropertyApi[]> => {
  const res = await axiosInstance.get("/property", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getRoomTypes = async (): Promise<RoomTypeApi[]> => {
  const res = await axiosInstance.get("/room-type", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getPropertyById = async (
  publicId: string
): Promise<PropertyDetailsApi> => {
  const res = await axiosInstance.get(`/property/${publicId}`, {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const getTourOperatorTypes = async (): Promise<
  TourOperatorTypeApi[]
> => {
  const res = await axiosInstance.get("/tour-operator-type", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const createPropertyAvailability = async (
  payload: CreatePropertyAvailabilityPayload
) => {
  const res = await axiosInstance.post(
    "/property-availability",
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const updatePropertyAvailability = async (
  publicId: string,
  payload: CreatePropertyAvailabilityPayload
) => {
  const res = await axiosInstance.put(
    `/property-availability/${publicId}`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getPropertyTypes = async (): Promise<PropertyTypeApi[]> => {
  const res = await axiosInstance.get("/property-types", {
    headers: getAuthHeader(),
  });

  return res.data;
};

export const updatePropertyAvailabilityStatus = async (
  publicId: string,
  payload: UpdateAvailabilityStatusPayload
) => {
  const res = await axiosInstance.patch(
    `/property-availability/${publicId}/status`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getPropertyAvailabilityById = async (
  publicId: string
): Promise<PropertyAvailabilityDetailsApi> => {
  const res = await axiosInstance.get(
    `/property-availability/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const releasePropertyAvailability = async (
  publicId: string
) => {
  const res = await axiosInstance.post(
    `/property-availability/${publicId}/release`,
    {},
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const createPropertyAvailabilityBlock = async (
  payload: CreatePropertyAvailabilityBlockPayload
) => {
  const res = await axiosInstance.post(
    "/property-availability-block",
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const updatePropertyAvailabilityBlock = async (
  publicId: string,
  payload: CreatePropertyAvailabilityBlockPayload
) => {
  const res = await axiosInstance.put(
    `/property-availability-block/${publicId}`,
    payload,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getPropertyAvailabilityBlocks = async (
  params: {
    SearchText?: string;
    pageNo: number;
    pageSize: number;
  }
): Promise<PropertyAvailabilityBlockListResponse> => {
  const res = await axiosInstance.get(
    "/property-availability-block/list",
    {
      headers: getAuthHeader(),
      params,
    }
  );

  return res.data;
};

export const getPropertyAvailabilityBlockById = async (
  publicId: string
): Promise<PropertyAvailabilityBlockDetailsApi> => {
  const res = await axiosInstance.get(
    `/property-availability-block/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const deletePropertyAvailabilityBlock = async (
  publicId: string
) => {
  const res = await axiosInstance.delete(
    `/property-availability-block/${publicId}`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};

export const getPropertyAvailabilityActivityLogs = async (
  publicId: string
): Promise<PropertyAvailabilityActivityLogsResponse> => {
  const res = await axiosInstance.get(
    `/property-availability/${publicId}/activity-logs`,
    {
      headers: getAuthHeader(),
    }
  );

  return res.data;
};